import { useState } from "react";
import { CreateCategory } from "../components/category/CreateCategory";
import { ListCategory } from "../components/category/ListCategory";
import { UpdateCategory } from "../components/category/UpdateCategory";

export const Category = () => {
  const [mode, setMode] = useState<"list" | "edit" | "create">("list");
  const [selectedId, setSelectedId] = useState<string | null>(null);
  if (mode === "create") {
    return <CreateCategory onBack={() => setMode("list")} />;
  }
  if (mode === "edit" && selectedId) {
    return (
      <UpdateCategory
        id={selectedId}
        onBack={() => {
          setSelectedId(null);
          setMode("list");
        }}
      />
    );
  }
  return (
    <ListCategory
      onCreate={() => setMode("create")}
      onUpdate={(id: string) => {
        setSelectedId(id);
        setMode("edit");
      }}
    />
  );
};
